@if( getActiveTab() == TAB_USERS ) {
    <app-admin-panel-users-component #tabUsers ></app-admin-panel-users-component>
    <!-- [filter]="pendingRejectedFilter" -->
}
@if( getActiveTab() == TAB_ROLES ) {
    <app-admin-panel-roles-component #tabRoles ></app-admin-panel-roles-component>
}
@if( getActiveTab() == TAB_OFFICES ) {
    <app-admin-panel-offices-component #tabOffices ></app-admin-panel-offices-component>
}
@if( getActiveTab() == TAB_AGENCIES ) {
    <app-admin-panel-agencies-component #tabAgencies ></app-admin-panel-agencies-component>
}
